/** @type {null | ((kind: 'notes' | 'favorites' | 'progress') => void | Promise<void>)} */
let userDataRemoteSyncHook = null;

export function registerUserDataRemoteSync(fn) {
  userDataRemoteSyncHook = fn;
}

/**
 * After local SQLite writes for user-owned data, push the matching table to Supabase when signed in.
 */
export async function notifyUserDataLocalChange(kind) {
  try {
    await userDataRemoteSyncHook?.(kind);
  } catch (e) {
    console.warn('notifyUserDataLocalChange', e);
  }
}
